import { RESET_UPLOADED_DOCUMENTS } from './ui.types';

export const resetUploadedDocuments = () => {
  return {
    type: RESET_UPLOADED_DOCUMENTS,
  };
};
